import React from 'react';
import { FemEntityLanding } from './pages/FemEntityLanding';
import { InvestorsPage } from './pages/InvestorsPage';
import { PractitionersPage } from './pages/PractitionersPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
export function App() {
  const path = window.location.pathname;
  if (path === '/investors') {
    return <InvestorsPage data-id="element-0" data-mp="3fb9jzcn93go5" />;
  }
  if (path === '/practitioners') {
    return <PractitionersPage data-id="element-1" data-mp="2rk41sqtu8cao" />;
  }
  if (path === '/privacy-policy') {
    return <PrivacyPolicyPage data-id="element-2" data-mp="2mm2m8fvmev3y" />;
  }
  return <FemEntityLanding data-id="element-3" data-mp="2mmvk0rclqa9y" />;
}